import { render, staticRenderFns } from "./DeleteAccountOrganizationsOwnerModal.vue?vue&type=template&id=65f782a0&scoped=true&lang=pug"
import script from "./DeleteAccountOrganizationsOwnerModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountOrganizationsOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountOrganizationsOwnerModal.vue?vue&type=style&index=0&id=65f782a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f782a0",
  null
  
)

export default component.exports